export const LANGS = [
  { code: "en", label: "English", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "fr", label: "Français", dir: "ltr" },
  { code: "es", label: "Español", dir: "ltr" },
  { code: "zh", label: "中文", dir: "ltr" },
];

export const T = {
  en: {
    nav_products: "Products", nav_process: "Process", nav_certs: "Certifications",
    nav_global: "Global Reach", nav_contact: "Contact", cta_quote: "Request a Quote",
    hero_badge: "Indian Export House · Est. Trust",
    hero_l1: "Export Quality Spices, Rice,", hero_l2: "Oil, Honey, Nuts & Textiles", hero_l3: "Exporter from India",
    hero_sub: "A trusted Indian export house delivering farm-fresh spices, rice, oils, honey, ghee and textiles to buyers across the globe — with genuine quality, honest grading and reliable shipping.",
    hero_explore: "Explore Our Products", hero_whatsapp: "Chat on WhatsApp", hero_now: "Now exporting",
    prod_eyebrow: "Our Catalogue", prod_title1: "A full pantry of India,", prod_title2: "export ready.",
    prod_intro: "Ten categories, hundreds of grades. Tell us your target market and volume — we build the specification and packaging around it.",
    prod_request: "Request pricing for",
    proc_eyebrow: "Farm to port", proc_title1: "One chain,", proc_title2: "fully in our hands.",
    proc_intro: "We control every step — from the farmer's field to your loading port. That means no surprises on quality, packing or timelines.",
    tex_eyebrow: "Textile Manufacturing",
    str_eyebrow: "Why buyers choose us", str_title1: "Our strength is your", str_title2: "peace of mind.",
    str_intro: "We are not just a supplier — we are the partner that protects your margin, your timeline and your reputation with every container we ship.",
    cert_eyebrow: "Licensed & registered", cert_title1: "Every licence", cert_title2: "an exporter needs.",
    cert_intro: "Fully compliant and export-ready. Tap any certificate to view the official document — complete transparency for our overseas buyers.",
    glob_eyebrow: "From Indian soil to the world", glob_title1: "Already trusted across the", glob_title2: "Gulf & Middle East.",
    glob_new: "+ New markets welcome",
    inq_eyebrow: "Place an order", inq_title1: "Let's get your", inq_title2: "container moving.",
    inq_intro: "Send us your requirement — product, grade, quantity and destination port. We reply with a quote, samples and complete export documentation.",
    c_whatsapp: "WhatsApp", c_email: "Email", c_call: "Call",
    f_name: "Full name *", f_company: "Company", f_email: "Email *", f_phone: "Phone / WhatsApp",
    f_country: "Destination country", f_product: "Product of interest",
    f_message: "Your requirement — grade, quantity, packaging, target port *",
    f_submit: "Send Inquiry", f_sending: "Sending...",
    f_ok: "Thank you! Your inquiry has reached Sunrise Mart. We'll reply shortly.",
    f_missing: "Please fill in your name, email and message.",
    f_err: "Something went wrong. Please try WhatsApp or email us directly.",
    map_open: "Open in Maps →",
    foot_ready1: "Ready to source from", foot_ready2: "India?",
    foot_blurb: "Indian exporter of spices, rice, oils, honey, ghee, millets, snacks and textiles for buyers worldwide.",
    foot_contact: "Contact", foot_markets: "Markets", foot_explore: "Explore",
    foot_map: "View on Google Maps →",
  },
  ar: {
    nav_products: "المنتجات", nav_process: "العملية", nav_certs: "الشهادات",
    nav_global: "الوصول العالمي", nav_contact: "اتصل بنا", cta_quote: "اطلب عرض سعر",
    hero_badge: "بيت تصدير هندي · ثقة راسخة",
    hero_l1: "بهارات وأرز وزيوت بجودة تصدير،", hero_l2: "عسل ومكسرات ومنسوجات", hero_l3: "مُصدِّر من الهند",
    hero_sub: "بيت تصدير هندي موثوق يقدّم البهارات الطازجة والأرز والزيوت والعسل والسمن والمنسوجات للمشترين حول العالم — بجودة أصيلة وتصنيف أمين وشحن موثوق.",
    hero_explore: "استكشف منتجاتنا", hero_whatsapp: "تواصل عبر واتساب", hero_now: "نصدّر الآن",
    prod_eyebrow: "كتالوجنا", prod_title1: "خزين الهند الكامل،", prod_title2: "جاهز للتصدير.",
    prod_intro: "عشر فئات ومئات الدرجات. أخبرنا بسوقك المستهدف والكمية — ونجهّز المواصفات والتعبئة حسب طلبك.",
    prod_request: "اطلب أسعار",
    proc_eyebrow: "من المزرعة إلى الميناء", proc_title1: "سلسلة واحدة،", proc_title2: "بالكامل بين أيدينا.",
    proc_intro: "نتحكم في كل خطوة — من حقل المزارع إلى ميناء التحميل. بلا مفاجآت في الجودة أو التعبئة أو المواعيد.",
    tex_eyebrow: "تصنيع المنسوجات",
    str_eyebrow: "لماذا يختارنا المشترون", str_title1: "قوتنا هي", str_title2: "راحة بالك.",
    str_intro: "لسنا مجرد مورّد — بل شريك يحمي أرباحك ومواعيدك وسمعتك مع كل حاوية نشحنها.",
    cert_eyebrow: "مرخّص ومسجّل", cert_title1: "كل ترخيص", cert_title2: "يحتاجه المصدّر.",
    cert_intro: "متوافقون تماماً وجاهزون للتصدير. اضغط أي شهادة لعرض المستند الرسمي — شفافية كاملة لمشترينا في الخارج.",
    glob_eyebrow: "من التربة الهندية إلى العالم", glob_title1: "موثوقون بالفعل في", glob_title2: "الخليج والشرق الأوسط.",
    glob_new: "+ أسواق جديدة مرحّب بها",
    inq_eyebrow: "قدّم طلبك", inq_title1: "لنبدأ بتحريك", inq_title2: "حاويتك.",
    inq_intro: "أرسل لنا متطلباتك — المنتج والدرجة والكمية وميناء الوصول. نرد بعرض سعر وعينات ومستندات تصدير كاملة.",
    c_whatsapp: "واتساب", c_email: "البريد", c_call: "اتصال",
    f_name: "الاسم الكامل *", f_company: "الشركة", f_email: "البريد الإلكتروني *", f_phone: "الهاتف / واتساب",
    f_country: "بلد الوجهة", f_product: "المنتج المطلوب",
    f_message: "متطلباتك — الدرجة، الكمية، التعبئة، ميناء الوصول *",
    f_submit: "إرسال الطلب", f_sending: "جارٍ الإرسال...",
    f_ok: "شكراً! وصل طلبك إلى Sunrise Mart وسنرد قريباً.",
    f_missing: "يرجى إدخال الاسم والبريد والرسالة.",
    f_err: "حدث خطأ. يرجى المراسلة عبر واتساب أو البريد مباشرة.",
    map_open: "افتح في الخرائط →",
    foot_ready1: "جاهز للاستيراد من", foot_ready2: "الهند؟",
    foot_blurb: "مصدّر هندي للبهارات والأرز والزيوت والعسل والسمن والدخن والوجبات والمنسوجات للمشترين حول العالم.",
    foot_contact: "اتصل بنا", foot_markets: "الأسواق", foot_explore: "استكشف",
    foot_map: "عرض على خرائط جوجل →",
  },
  fr: {
    nav_products: "Produits", nav_process: "Processus", nav_certs: "Certifications",
    nav_global: "Portée mondiale", nav_contact: "Contact", cta_quote: "Demander un devis",
    hero_badge: "Maison d'export indienne · Confiance établie",
    hero_l1: "Épices, riz, huile de qualité export,", hero_l2: "miel, fruits secs & textiles", hero_l3: "Exportateur d'Inde",
    hero_sub: "Une maison d'export indienne de confiance livrant épices, riz, huiles, miel, ghee et textiles frais à des acheteurs du monde entier — qualité authentique, tri honnête et expédition fiable.",
    hero_explore: "Découvrir nos produits", hero_whatsapp: "Discuter sur WhatsApp", hero_now: "Exportés actuellement",
    prod_eyebrow: "Notre catalogue", prod_title1: "Tout le garde-manger de l'Inde,", prod_title2: "prêt à l'export.",
    prod_intro: "Dix catégories, des centaines de qualités. Indiquez votre marché et votre volume — nous adaptons spécifications et emballage.",
    prod_request: "Demander un prix pour",
    proc_eyebrow: "De la ferme au port", proc_title1: "Une chaîne,", proc_title2: "entièrement maîtrisée.",
    proc_intro: "Nous contrôlons chaque étape — du champ au port de chargement. Aucune surprise sur la qualité, l'emballage ou les délais.",
    tex_eyebrow: "Fabrication textile",
    str_eyebrow: "Pourquoi nous choisir", str_title1: "Notre force, c'est votre", str_title2: "tranquillité d'esprit.",
    str_intro: "Nous ne sommes pas qu'un fournisseur — nous protégeons votre marge, vos délais et votre réputation à chaque conteneur.",
    cert_eyebrow: "Licencié & enregistré", cert_title1: "Chaque licence", cert_title2: "d'un exportateur.",
    cert_intro: "Entièrement conforme et prêt à l'export. Cliquez sur un certificat pour voir le document officiel — transparence totale.",
    glob_eyebrow: "Du sol indien au monde", glob_title1: "Déjà de confiance dans le", glob_title2: "Golfe & Moyen-Orient.",
    glob_new: "+ Nouveaux marchés bienvenus",
    inq_eyebrow: "Passer commande", inq_title1: "Faisons avancer votre", inq_title2: "conteneur.",
    inq_intro: "Envoyez votre besoin — produit, qualité, quantité et port de destination. Nous répondons avec devis, échantillons et documents d'export.",
    c_whatsapp: "WhatsApp", c_email: "E-mail", c_call: "Appeler",
    f_name: "Nom complet *", f_company: "Société", f_email: "E-mail *", f_phone: "Téléphone / WhatsApp",
    f_country: "Pays de destination", f_product: "Produit souhaité",
    f_message: "Votre besoin — qualité, quantité, emballage, port cible *",
    f_submit: "Envoyer la demande", f_sending: "Envoi...",
    f_ok: "Merci ! Votre demande est bien reçue par Sunrise Mart. Réponse rapide.",
    f_missing: "Veuillez indiquer nom, e-mail et message.",
    f_err: "Une erreur est survenue. Contactez-nous via WhatsApp ou e-mail.",
    map_open: "Ouvrir dans Maps →",
    foot_ready1: "Prêt à sourcer depuis", foot_ready2: "l'Inde ?",
    foot_blurb: "Exportateur indien d'épices, riz, huiles, miel, ghee, millets, snacks et textiles pour le monde entier.",
    foot_contact: "Contact", foot_markets: "Marchés", foot_explore: "Explorer",
    foot_map: "Voir sur Google Maps →",
  },
  es: {
    nav_products: "Productos", nav_process: "Proceso", nav_certs: "Certificaciones",
    nav_global: "Alcance global", nav_contact: "Contacto", cta_quote: "Solicitar cotización",
    hero_badge: "Casa exportadora india · Confianza sólida",
    hero_l1: "Especias, arroz, aceite de calidad,", hero_l2: "miel, frutos secos y textiles", hero_l3: "Exportador de la India",
    hero_sub: "Una casa exportadora india de confianza que entrega especias, arroz, aceites, miel, ghee y textiles frescos a compradores de todo el mundo — calidad genuina, clasificación honesta y envío confiable.",
    hero_explore: "Ver nuestros productos", hero_whatsapp: "Chatear por WhatsApp", hero_now: "Exportando ahora",
    prod_eyebrow: "Nuestro catálogo", prod_title1: "Toda la despensa de India,", prod_title2: "lista para exportar.",
    prod_intro: "Diez categorías, cientos de grados. Díganos su mercado y volumen — adaptamos especificación y empaque.",
    prod_request: "Solicitar precio para",
    proc_eyebrow: "Del campo al puerto", proc_title1: "Una cadena,", proc_title2: "totalmente en nuestras manos.",
    proc_intro: "Controlamos cada paso — del campo del agricultor a su puerto de carga. Sin sorpresas en calidad, empaque o plazos.",
    tex_eyebrow: "Fabricación textil",
    str_eyebrow: "Por qué nos eligen", str_title1: "Nuestra fortaleza es su", str_title2: "tranquilidad.",
    str_intro: "No somos solo un proveedor — somos el socio que protege su margen, su plazo y su reputación en cada contenedor.",
    cert_eyebrow: "Licenciado y registrado", cert_title1: "Cada licencia", cert_title2: "que un exportador necesita.",
    cert_intro: "Totalmente conforme y listo para exportar. Toque cualquier certificado para ver el documento oficial — transparencia total.",
    glob_eyebrow: "De la tierra india al mundo", glob_title1: "Ya de confianza en el", glob_title2: "Golfo y Oriente Medio.",
    glob_new: "+ Nuevos mercados bienvenidos",
    inq_eyebrow: "Hacer un pedido", inq_title1: "Pongamos en marcha su", inq_title2: "contenedor.",
    inq_intro: "Envíenos su requerimiento — producto, grado, cantidad y puerto de destino. Respondemos con cotización, muestras y documentación.",
    c_whatsapp: "WhatsApp", c_email: "Correo", c_call: "Llamar",
    f_name: "Nombre completo *", f_company: "Empresa", f_email: "Correo *", f_phone: "Teléfono / WhatsApp",
    f_country: "País de destino", f_product: "Producto de interés",
    f_message: "Su requerimiento — grado, cantidad, empaque, puerto destino *",
    f_submit: "Enviar solicitud", f_sending: "Enviando...",
    f_ok: "¡Gracias! Su solicitud llegó a Sunrise Mart. Responderemos pronto.",
    f_missing: "Complete nombre, correo y mensaje.",
    f_err: "Algo salió mal. Escríbanos por WhatsApp o correo.",
    map_open: "Abrir en Maps →",
    foot_ready1: "¿Listo para abastecerse de", foot_ready2: "India?",
    foot_blurb: "Exportador indio de especias, arroz, aceites, miel, ghee, mijos, snacks y textiles para todo el mundo.",
    foot_contact: "Contacto", foot_markets: "Mercados", foot_explore: "Explorar",
    foot_map: "Ver en Google Maps →",
  },
  zh: {
    nav_products: "产品", nav_process: "流程", nav_certs: "资质认证",
    nav_global: "全球业务", nav_contact: "联系", cta_quote: "获取报价",
    hero_badge: "印度出口商 · 值得信赖",
    hero_l1: "出口级香料、大米、食用油、", hero_l2: "蜂蜜、坚果与纺织品", hero_l3: "来自印度的出口商",
    hero_sub: "值得信赖的印度出口商，向全球买家供应新鲜香料、大米、食用油、蜂蜜、酥油和纺织品 —— 品质纯正、分级诚信、发货可靠。",
    hero_explore: "浏览我们的产品", hero_whatsapp: "WhatsApp 咨询", hero_now: "现正出口",
    prod_eyebrow: "产品目录", prod_title1: "印度的丰盛物产，", prod_title2: "随时可出口。",
    prod_intro: "十大类别，数百种规格。告诉我们您的目标市场和数量 —— 我们按需定制规格与包装。",
    prod_request: "咨询报价：",
    proc_eyebrow: "从农场到港口", proc_title1: "一条链条，", proc_title2: "全程自控。",
    proc_intro: "从农户的田间到您的装货港，我们掌控每一步 —— 品质、包装与交期绝无意外。",
    tex_eyebrow: "纺织制造",
    str_eyebrow: "买家为何选择我们", str_title1: "我们的实力，就是您的", str_title2: "安心。",
    str_intro: "我们不只是供应商 —— 每一个集装箱，都守护您的利润、交期与声誉。",
    cert_eyebrow: "持证注册", cert_title1: "出口商所需的", cert_title2: "每一张证照。",
    cert_intro: "完全合规、随时可出口。点击任意证书查看官方文件 —— 为海外买家提供完全透明。",
    glob_eyebrow: "从印度走向世界", glob_title1: "已深受信赖于", glob_title2: "海湾与中东地区。",
    glob_new: "+ 欢迎开拓新市场",
    inq_eyebrow: "下单询价", inq_title1: "让您的货柜", inq_title2: "即刻启程。",
    inq_intro: "发送您的需求 —— 产品、等级、数量与目的港。我们将回复报价、样品及完整出口文件。",
    c_whatsapp: "WhatsApp", c_email: "邮箱", c_call: "致电",
    f_name: "全名 *", f_company: "公司", f_email: "邮箱 *", f_phone: "电话 / WhatsApp",
    f_country: "目的国", f_product: "感兴趣的产品",
    f_message: "您的需求 —— 等级、数量、包装、目的港 *",
    f_submit: "发送询盘", f_sending: "发送中...",
    f_ok: "谢谢！您的询盘已送达 Sunrise Mart，我们将尽快回复。",
    f_missing: "请填写姓名、邮箱和留言。",
    f_err: "出错了，请通过 WhatsApp 或邮箱直接联系我们。",
    map_open: "在地图中打开 →",
    foot_ready1: "准备从", foot_ready2: "印度采购？",
    foot_blurb: "印度出口商，向全球买家供应香料、大米、食用油、蜂蜜、酥油、杂粮、零食与纺织品。",
    foot_contact: "联系", foot_markets: "市场", foot_explore: "浏览",
    foot_map: "在 Google 地图查看 →",
  },
};
